import http from '@/utils/http';

// 学生总人数
export const getStudentTotal = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/student/all',
        method: 'get',
        params
    })
}
//  今年学生人数
export const getStudentYear = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/student/year',
        params
    })
}
//  今年学生人数（柱状图 按学校分类）
export const getStudentYearBySchool = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/student/school',
        params
    })
}
//  学生障碍类型占比（环形图）
export const getStudentDisability = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/studentDisability/all',
        params
    })
}
//  学生障碍类型占比（柱状图）
export const getStudentDisability2 = (params) => {
    return http({
        url: '/api/visualcrc/v2/index/studentDisability',
        params
    })
}




